import { IVoucher, VoucherStatus, VoucherType, Customer, IDocument } from './interfaces'
import { autoserializeAs } from 'cerialize'
import { DateSerializer } from '@/helpers/model-utils'

export default class Voucher implements IVoucher {

  @autoserializeAs('id')
  public id: string = ''

  @autoserializeAs('name')
  public name: string = ''

  @autoserializeAs('unit')
  public unit: number = 0

  @autoserializeAs('per_unit')
  public perUnit: number = 0

  @autoserializeAs(DateSerializer, 'issue_date')
  public issueDate: Date = new Date()

  @autoserializeAs('customer_id')
  public customerId: string = ''

  @autoserializeAs('customer')
  public customer: Customer | undefined

  @autoserializeAs('type')
  public type: VoucherType = 'receipt'    // ใบสำคัญรับ,​ ใบสำคัญจ่าย

  @autoserializeAs('status')
  public status: VoucherStatus = 'created'

  public get totalAmount(): number {
    return this.unit * this.perUnit
  }

  public createDocument(): IDocument {
    return {
      code: this.id,
      issueDate: this.issueDate,
      customer: this.customer!,
      totalAmount: this.totalAmount,
      items: [{
        name: this.name,
        unit: this.unit,
        perUnit: this.perUnit,
        total: this.totalAmount,
      }],
      documentType: () => {
        return this.type === 'payment' ? 'payment_voucher' : 'receipt_voucher'
      },
    }
  }
}
